import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, of, Subject } from 'rxjs';
import { login } from '../BAL/login.model';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient,
    public sanitizer: DomSanitizer,
    private translate: TranslateService
    , private router: Router) { }

  GetTokens() {
    return new HttpHeaders({
      'Token': this.CheckandGetToken()
    });
  }
  userAuthentication(userName, password) {

    var data = "username=" + userName + "&password=" + password + "&grant_type=password";
    // var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });

    return this.http.post<login[]>(environment.rootUrl + '/api/login/authenticate', {
      Email: userName,
      Password: password
    });
  }
  CheckUserAuthentication(rootScope) {

    var _language = localStorage.getItem('_Language');
    environment.Language = _language;
    var _dir = localStorage.getItem('_dir');
    environment.dir = _dir;

    if (sessionStorage.getItem('rootScope') == null || sessionStorage.getItem('rootScopeLocation') == null) {
      rootScope = null;
    }

    if (rootScope == null || rootScope == 'null') {
      var rootScopeLS = sessionStorage.getItem('rootScope');
      var rootScopeSLS = sessionStorage.getItem('rootScopeLocation');

      if (rootScopeLS == '' || rootScopeLS == null) {
        environment.rootScope == null;
        this.router.navigate(['/login-in']);

      }
      else {
        environment.rootScope = JSON.parse(rootScopeLS);
      }

      if (rootScopeSLS == '' || rootScopeSLS == null) {
        environment.rootScope == null;
        this.router.navigate(['/login-in']);
      }
      else {
        environment.LocationSelected = JSON.parse(rootScopeSLS);
        environment.Currency = environment.LocationSelected.Currency;
        debugger
        if (environment.rootScope.User.IsOdoo !== undefined && environment.rootScope.User.IsOdoo !== null) {
          environment.IsOdoo = environment.rootScope.User.IsOdoo;
        }

            console.log(environment.rootScope);
            
        if (environment.rootScope.APIKeyOdoo != null) {
          environment.OdooApiKey = environment.rootScope.APIKeyOdoo;
        }

      }
    }
  }
  CheckTokenDB(rsp) {
    // if (rsp == null || rsp == undefined || rsp == 'null' || rsp == '') {
    //   this.router.navigate(['/login-in']);
    //   return false;
    // }
    if (rsp.Status == 1001) {
      this.router.navigate(['/login-in']);
      return false;
    }
  }
  CheckandGetToken() {
    const token = localStorage.getItem('token'); // or use your actual token retrieval method
    if (token == null || token == undefined || token == 'null' || token == '') {
      this.router.navigate(['/login-in']);
      return;
    }
    else {
      return token;
    }
  }
  Code(formname) {
    return this.http.get<any[]>(environment.rootUrl + '/api/inventory/codegenerate/' + formname + '/' + environment.rootScope.SuperUserID, { headers: this.GetTokens() });
  }
  CheckUserPermissions(Formname, ParentFormname, Role) {

    var rootScope = environment.rootScope;

    if (rootScope.Permissions != null && rootScope.Permissions.length > 0) {
      if (rootScope != null && rootScope != 'null') {
        var permissions = rootScope.Permissions.filter(function (obj) {
          return obj.FormName == ParentFormname;
        })[0];

        var _accessParent = permissions.Access;
        // Role == "Access" ? permissions.Access :
        //   Role == "New" ? permissions.New :
        //     Role == "Edit" ? permissions.Edit :
        //       Role == "Remove" ? permissions.Remove : false;

        if (_accessParent) {
          if (permissions.SubRoles.length > 0) {
            var permissionsChild = permissions.SubRoles.filter(function (obj) {
              return obj.FormName == Formname;
            })[0];
            if (permissionsChild != undefined && permissionsChild != null) {
              var _accessChild =
                Role == "Access" ? permissionsChild.Access :
                  (Role == "New" || Role == "Add") ? permissionsChild.New :
                    Role == "Edit" ? permissionsChild.Edit :
                      Role == "Remove" ? permissionsChild.Remove : false;

              if (_accessChild) {

              } else {
                this.router.navigate(['/accessdenied']);
                return false;
              }
            }
          }
        }
        else {
          this.router.navigate(['/accessdenied']);
          return false;
        }
      }
    }
    return true;
  }
  CheckAllowedUserPermissions(Formname, ParentFormname, Role) {

    var rootScope = environment.rootScope;

    if (rootScope.Permissions != null && rootScope.Permissions.length > 0) {
      if (rootScope != null && rootScope != 'null') {
        var permissions = rootScope.Permissions.filter(function (obj) {
          return obj.FormName == ParentFormname;
        })[0];

        var _accessParent = permissions.Access;
        // Role == "Access" ? permissions.Access :
        //   Role == "New" ? permissions.New :
        //     Role == "Edit" ? permissions.Edit :
        //       Role == "Remove" ? permissions.Remove : false;

        if (_accessParent) {
          if (permissions.SubRoles.length > 0) {
            var permissionsChild = permissions.SubRoles.filter(function (obj) {
              return obj.FormName == Formname;
            })[0];
            if (permissionsChild != undefined && permissionsChild != null) {
              var _accessChild =
                Role == "Access" ? permissionsChild.Access :
                  (Role == "New" || Role == "Add") ? permissionsChild.New :
                    Role == "Edit" ? permissionsChild.Edit :
                      Role == "Remove" ? permissionsChild.Remove : false;

              if (_accessChild) {

              } else {
                return false;
              }
            }
          }
        }
        else {
          return false;
        }
      }
    }
    return true;
  }
  GetTranslatedValue(str) {

    const currentLang = this.translate.currentLang; // get current language
    const returnValue = this.translate.translations[currentLang][str]; // get converted string from current language
    if (returnValue === undefined) {
      return this.translate.translations.en_merch[str]; // if value is getting undefined then return default language string, en_merch is default english language file here
    } else {
      return returnValue;
    }
  }
  dateToTicks(date) {
    const epochOffset = 621355968000000000;
    const ticksPerMillisecond = 10000;

    const ticks = date.getTime() * ticksPerMillisecond + epochOffset;

    return ticks;
  }
  formatCurrency(currency: string): string {
    if (currency === 'SAR') {
      return `<i class=" icon-saudi_riyal" aria-hidden="true"></i>`;  // Adding the icon for SAR
    }
    return currency;  // Just return the currency value for other cases
  }
  Logout() {
    environment.rootScope = null;
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login-in']);
  }
}
